import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation resetPasswordMutation($input: ResetPasswordInput!) {
		resetPassword(input: $input) {
			success
			errors
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input};
	return commitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
